export default [    
    {
        title: 'Date',
        id: 'date',
        classes: 'date-column',
        fixable: true,
        sortable: true,
        comparable: true
    },
    {
        title: 'Market',
        id: 'marketName',
        sortable: false,
        fixable: true
    },
    {
        title: 'Site',
        id: 'siteName',
        sortable: false,
        fixable: true
    },
    {
        title: 'Source',
        id: 'sourceName',
        sortable: false,
        fixable: true
    },
    {
        title: 'Device',
        id: 'deviceName',
        sortable: false,
        fixable: true
    },
    {
        title: 'Campaign',
        id: 'campaignName',
        sortable: true,
        fixable: true
    },
    {
        title: 'AdGroup',
        id: 'adGroupName',
        sortable: true,
        fixable: true
    },
    {
        title: 'Impressions',
        id: 'impressions',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'Bought',
        id: 'boughtClicks',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'adCTR',
        id: 'adCtr',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'Cost',
        id: 'cost',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'CPC',
        id: 'cpc',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    }, 
    {
        title: 'CPA',
        id: 'cpa',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'Avg. Pos.',
        id: 'avgPos',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'Max CPC',
        id: 'maxCpc',
        sortable: false,
        comparable: true,
        fixable: true
    },
    {
        title: 'Max CPA',
        id: 'maxCpa',
        sortable: false,
        comparable: true,
        fixable: true
    },
    {
        title: 'Sold',
        id: 'soldClicks',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'Earned',
        id: 'revenue',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    }, 
    {
        title: 'opCTR',
        id: 'opCtr',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'RPS',
        id: 'rps',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'RPC',
        id: 'rpc',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'Profit',
        id: 'profit',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'Margin',
        id: 'margin',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'TQ',
        id: 'tq',
        sortable: false,
        comparable: true,
        fixable: true
    },
    {
        title: 'Scrub',
        id: 'scrubRate',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'Conv.',
        id: 'conversions',
        sortable: true,
        defaultSort: 'desc',
        comparable: true,
        fixable: true
    },
    {
        title: 'Label',
        id: 'adGroupLabels',
        comparable: true,
        sortable: false,
        fixable: true
    },
    {
        title: 'AdGroup Status',        
        id: 'adGroupStatus',
        sortable: false,
        comparable: true,
        fixable: true
    },
    {
        title: 'KWR num',
        id: 'kwrNum',
        sortable: false,
        comparable: true,
        fixable: true
    },   
]


// WEBPACK FOOTER //
// ./src/configs/adgroup-report2-config.js